import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class StockAdjustmentReasonReferenceService extends BaseReferenceService {
  constructor() {
    super('StockAdjustmentReasonReference');
  }
}
